export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const OVERVIEW_TAB = "overview";
export const INVOICES_TAB = "invoices";
export const TASKS_TAB = "tasks";
export const PROJECTPLAN_TAB = "projectplan";
export const ATTACHMENTS_TAB = "attachments";
export const TRIAGE_TAB = "triage";

